import * as React from "react";

const CloseModalIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14">
        <path d="M1.4 14 0 12.6 5.6 7 0 1.4 1.4 0 7 5.6 12.6 0 14 1.4 8.4 7l5.6 5.6-1.4 1.4L7 8.4z"></path>
    </svg>
);

export default CloseModalIconSVG;
